import type { RootState } from 'store';
import { createSelector } from 'reselect';
import type { SimulationGuarantees } from 'store/storageunits/types';

export const getProjectData = (state: RootState) =>
  state.documentMetadata.projectData;

export const getDrawnBy = (state: RootState) =>
  state.documentMetadata.projectData.drawnBy;

export const getApprovedBy = (state: RootState) =>
  state.documentMetadata.projectData.approvedBy;

export const getFlowsheetMetadata = (state: RootState) =>
  state.documentMetadata.flowsheetMetadata;

export const getCustomConnectionColor = (state: RootState) =>
  state.documentMetadata.flowsheetMetadata?.customConnectionColor;

export const getRiskAssessmentSimulationSettings = (state: RootState) =>
  state.documentMetadata.flowsheetMetadata
    ?.riskAssessmentSimulationSettings ?? {
    simulatePeakCapacity: true,
    simulatePSD: true,
  };

/**
 * Transforms RiskAssessmentSimulationSettings into SimulationGuarantees format.
 * Provides a more concise representation for consumption by risk assessment logic.
 *
 * @returns SimulationGuarantees with peakCapacity, avgCapacity, and psd flags
 */
export const getSimulationGuarantees = createSelector(
  getRiskAssessmentSimulationSettings,
  (settings): SimulationGuarantees => ({
    peakCapacity: settings.simulatePeakCapacity,
    psd: settings.simulatePSD,
  }),
);
